import * as React from 'react';
import Control from '../controls/Select';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
// Just a quick'n dirty fix until we revamp that whole mess...
// Prevent the label/select inline "effect".
// $FlowFixMe[missing-local-annot]
const Select = props => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx(Control, {
    ...props
  })
});
const component = decorateControl(Select, FormGroup);
const SelectField = props => /*#__PURE__*/_jsx(FormField, {
  ...props,
  component: component
});
export default SelectField;